





























































































































































import { Component, Vue } from 'vue-property-decorator';
import * as api from '@/api';
import axios from 'axios';
import UserModule from '@/store/modules/user';
import { Dialog, Toast } from 'vant';
import SessionModule from '@/store/modules/session';
@Component({})
export default class PersonInfoIndex extends Vue {
  studentInfo: Partial<any> = {
    deptId: '',
    deptName: '',
    imageName: '',
    name: '',
    sex: '',
    nation: '',
    workUnit: '',
    job: '',
    phone: '',
    postRank: null,
    unManageRank: null,
    city: '',
  };

  readonly userModule = UserModule.info;

  postRankData: any = [];
  unManageRankData = [];

  stuImgs: any = [];

  onUntie() {
    Dialog.confirm({
      title: '提示信息',
      message: '是否确认解除当前微信绑定登录？解除后不能自动登录到该系统。',
    })
      .then(async () => {
        const { data } = await api.Trainees.weixinUnbind_POST({
          id: JSON.parse(localStorage.getItem('ACTIVE_SESSION_KEY')).openId,
        });
        if (data) {
          Dialog.alert({
            title: '提示信息',
            message: '解绑成功',
          });
          await UserModule.LogOut();
          const url = new URL(window.location.href).origin;
          window.history.replaceState({}, '', url);
          location.reload();
        } else {
          Dialog.alert({
            title: '提示信息',
            message: '解绑失败',
          });
        }
      })
      .catch(() => {
        // on cancel
      });
  }

  async LogOut() {
    await UserModule.LogOut();
    const url = new URL(window.location.href).origin;
    window.history.replaceState({}, '', url);
    location.reload();
  }

  toUpdatePhone() {
    this.$router.push({
      name: 'phone',
      query: {
        phone: this.studentInfo.phone!,
      },
    });
  }
  toEditUserInfo() {
    this.$router.push({
      name: 'editUserInfo',
      params: {
        userInfo: JSON.stringify(this.studentInfo),
      },
    });
  }

  async mounted() {
    let that = this;
    await that.getPersonInfo();
    await that.getRank();
    await that.getStuImg('学员头像', that.studentInfo.imageName);
  }

  async getRank() {
    await apiAxios
      .get('/api/Standard/GetItemFromCode?code=manageRank', axiosOptions)
      .then(res => {
        if (res) {
          this.postRankData = res.data.data.reduce((a, b) => {
            a[b.order] = b.name;
            return a;
          }, {});
        }
      })
      .catch(err => {
        console.log(err);
      });
    await apiAxios
      .get('/api/Standard/GetItemFromCode?code=unManageRank', axiosOptions)
      .then(res => {
        if (res) {
          this.unManageRankData = res.data.data.reduce((a, b) => {
            a[b.order] = b.name;
            return a;
          }, {});
        }
      })
      .catch(err => {
        console.log(err);
      });
  }

  // 获取单位
  async getAllDepts() {
    try {
      const { data } = await api.AccountApp.getAllDepts_GET();
      const name = data.find((d: any) => d.deptId == this.studentInfo.deptId).deptName;
      this.$set(this.studentInfo, 'deptName', name);
    } catch (err) {
      console.log(err);
    }
  }

  async getPersonInfo() {
    Toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true,
      message: '加载中...',
    });
    const { data } = await api.AccountApp.getUserPersonalInfo_GET();
    this.studentInfo = data!;
    this.getAllDepts();
    Toast.clear();
  }
  // 获取学员头像
  async getStuImg(keyName: string, key: string) {
    const { data } = await apiAxios.get('/api/NewAttachment/GetAttachmens', {
      params: {
        StringKey1: key,
        Category: keyName,
      },
    });
    this.stuImgs = data;
  }
}
export interface AxiosRequestConfig {
  baseURL?: string;
  headers: object;
}
const axiosOptions: AxiosRequestConfig = {
  baseURL: process.env.VUE_APP_ROOT,
  headers: {
    Authorization: `${'Bearer ' + UserModule.getToken}`,
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
};
const apiAxios = axios.create(axiosOptions);
